import { PMButton, PMEmptyState, PMProgress } from "@/ds/vendor";
import { Mark } from "./Mark";

export function Splash({ title, detail, onRetry, onSignOut }: { title: string; detail?: string; onRetry?: () => void; onSignOut?: () => void }) {
  const busy = !detail && !onRetry;
  return (
    <div className="splash">
      <Mark size={44} />
      {busy ? (
        <div className="splash-busy">
          <div className="splash-title">{title}</div>
          <PMProgress variant="linear" value={null} label={title} style={{ width: 220 }} />
        </div>
      ) : (
        <PMEmptyState
          title={title}
          description={detail}
          action={onRetry ? <PMButton onClick={onRetry}>Try again</PMButton> : undefined}
          secondaryAction={onSignOut ? <PMButton variant="text" onClick={onSignOut}>Sign out</PMButton> : undefined}
        />
      )}
    </div>
  );
}
